import { Button, SelectGeneric } from 'ypf-pas-general-ui-components';
import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { useFilterContext } from '../../../../context/FilterDetailSDSContext';
import { getLines, getPosition } from '../../../../services/serviceRequest';
import PositionLineContainer from '../../../PositionLineContainer/PositionLineContainer';
import { proveedorNotificador } from '../../../../security/constantsRols';
import { checkRol } from '../../../../security';
import {
  getEventsMSDSDetail,
  getLinesMSDSDetail,
  getLocationsMSDSDetail,
  getPositionMSDSDetail,
  getTowerEquipmentMSDSDetail,
  getTypeOfLocationMSDSDetail
} from '../../../../services/monthlyServiceRequest';

import styles from './FilterForm.module.scss';

const FilterForm = ({ show, isOrderByUbication }) => {
  const { id } = useParams();

  const location = useLocation();

  const isProviderMSDS =
    checkRol(proveedorNotificador) && location.pathname.includes('detailmonthly');

  const [newParams, setNewParams] = useState({});
  const [errorPositionLine, setErrorPositionLine] = useState('');

  const { formikFilters, handleSaveFilters } = useFilterContext();

  const { values, setFieldValue, setValues, handleSubmit } = formikFilters;

  const initialValuesFormik = {
    events: [],
    ubicationType: null,
    ubications: null,
    towerEquipments: [],
    position: null,
    line: null,
    posicionesLineas: [],
    haveFilters: false
  };

  const getPositionOptions = async () => {
    const options = isProviderMSDS ? await getPositionMSDSDetail(id) : await getPosition(id);

    return setNewParams((prevState) => ({
      ...prevState,
      positionOptions: [...options]
    }));
  };

  const getLineOptions = async (value) => {
    const options = isProviderMSDS
      ? await getLinesMSDSDetail(id, value?.id)
      : await getLines(id, value?.id);

    return setNewParams((prevState) => ({
      ...prevState,
      lineOptions: [...options]
    }));
  };

  const getEventsOptions = async () => {
    const options = await getEventsMSDSDetail(id);

    if (values.eventosIds) {
      const eventsSelected = values.eventosIds?.map((event) => event);
      const eventsOptionsToSelect = options
        ?.filter((option) => eventsSelected?.includes(option.id))
        .map((val) => ({ value: val.id, label: val.nombre, id: val.id, nombre: val.nombre }));

      setFieldValue('events', eventsOptionsToSelect);
    }

    return setNewParams((prevState) => ({
      ...prevState,
      eventsOptions: [...options]
    }));
  };

  const getTypeOfLocationsOptions = async () => {
    const options = await getTypeOfLocationMSDSDetail(id);

    if (values?.tipoUbicacionesIds) {
      const typeOflocationSelected = values?.tipoUbicacionesIds?.map((event) => event);
      const typeOfLocationOptionsToSelect = options
        ?.filter((option) => typeOflocationSelected?.includes(option.id))
        .map((val) => ({ value: val.id, label: val.nombre, id: val.id, nombre: val.nombre }));

      if (typeOfLocationOptionsToSelect.length)
        setFieldValue('ubicationType', typeOfLocationOptionsToSelect[0]);
    }

    return setNewParams((prevState) => ({
      ...prevState,
      ubicationTypeOptions: [...options]
    }));
  };

  const getLocationsOptions = async () => {
    const options = await getLocationsMSDSDetail(id);

    if (values?.ubicacionesIds) {
      const locationsSelected = values.ubicacionesIds?.map((event) => event);
      const locationsOptionsToSelect = options
        ?.filter((option) => locationsSelected?.includes(option.id))
        .map((val) => ({ value: val.id, label: val.nombre, id: val.id, nombre: val.nombre }));

      if (locationsOptionsToSelect.length) setFieldValue('ubications', locationsOptionsToSelect[0]);
    }

    return setNewParams((prevState) => ({
      ...prevState,
      ubicationsOptions: [...options]
    }));
  };

  const getTowerEquipmentOptions = async () => {
    const options = await getTowerEquipmentMSDSDetail(id);

    if (values?.equiposIds) {
      const towerEquipmentSelected = values?.equiposIds?.map((event) => event);
      const towerEquipmentOptionsToSelect = options
        ?.filter((option) => towerEquipmentSelected?.includes(option.id))
        .map((val) => ({ value: val.id, label: val.nombre, id: val.id, nombre: val.nombre }));

      setFieldValue('towerEquipments', towerEquipmentOptionsToSelect);
    }

    return setNewParams((prevState) => ({
      ...prevState,
      towerEquipmentsOptions: [...options]
    }));
  };

  useEffect(() => {
    if (show) {
      getPositionOptions();
      if (isProviderMSDS) {
        getEventsOptions();
        getTypeOfLocationsOptions();
        getLocationsOptions();
        getTowerEquipmentOptions();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleClear = () => {
    setValues({ ...initialValuesFormik, haveFilters: true, isPending: values?.isPending });
  };
  const cleanErrorPositionLine = () => {
    setErrorPositionLine(() => '');
  };

  const handleChangePositionLine = ({ valueLine }) => {
    const positionLineObject = {
      posicionId: values.position.nombre,
      lineaId: valueLine.nombre
    };
    // Validate that the Position and Line fields are complete
    const hasPositionLine = Object.keys(positionLineObject).every(
      (key) => positionLineObject[key] !== null
    );

    if (hasPositionLine) {
      const newLabelPositionLine = `P${positionLineObject.posicionId}-L${positionLineObject.lineaId}`;
      // Validate whether the added PL already exists
      const cleanPositionLine = values.posicionesLineas?.find(
        (pl) => pl.label === newLabelPositionLine
      );

      if (!cleanPositionLine) {
        values.posicionesLineas?.push({
          label: newLabelPositionLine,
          posicion: values.position?.nombre,
          posicionId: values.position?.id,
          lineaId: valueLine.id,
          linea: valueLine.nombre
        });
        setValues({ ...values, position: null, line: null });
      } else {
        setErrorPositionLine('La posición y línea ya fue seleccionada');
      }
    }
  };

  const handleSubmitForm = (data) => {
    data.preventDefault();
    handleSubmit();
  };

  return (
    <div className="content-filter narrow-scrollbar">
      <form onSubmit={handleSubmitForm}>
        {isProviderMSDS && (
          <>
            {isOrderByUbication && (
              <Row>
                <SelectGeneric
                  clearable
                  defaultValueOneOption={false}
                  isMulti
                  label="Tipo de evento"
                  name="events"
                  onChange={(newValue) => {
                    setFieldValue('events', newValue);
                    setFieldValue(
                      'eventosIds',
                      newValue?.map((team) => team?.id)
                    );
                  }}
                  options={newParams?.eventsOptions}
                  placeholder="Seleccioná un tipo de evento"
                  type="text"
                  value={values.events}
                  withSelect="100%"
                />
              </Row>
            )}
            <Row>
              <SelectGeneric
                clearable
                defaultValueOneOption={false}
                label="Tipo de ubicación"
                name="ubicationType"
                onChange={(newValue) => {
                  if (newValue === null || newValue === undefined) {
                    setFieldValue('tipoUbicacionesIds', newValue);
                  }
                  setFieldValue('ubicationType', newValue);
                }}
                options={newParams?.ubicationTypeOptions}
                placeholder="Seleccioná un tipo de ubicación"
                type="text"
                value={values.ubicationType}
                withSelect="100%"
              />
            </Row>
            <Row>
              <SelectGeneric
                clearable
                defaultValueOneOption={false}
                label="Ubicación"
                name="ubications"
                onChange={(newValue) => {
                  if (newValue === null || newValue === undefined) {
                    setFieldValue('ubicacionesIds', newValue);
                  }
                  setFieldValue('ubications', newValue);
                }}
                options={newParams.ubicationsOptions}
                placeholder="Seleccioná una ubicación"
                type="text"
                value={values.ubications}
                withSelect="100%"
              />
            </Row>
            {isOrderByUbication && (
              <Row>
                <SelectGeneric
                  clearable
                  defaultValueOneOption={false}
                  isMulti
                  label="Equipo de torre"
                  name="towerEquipments"
                  onChange={(newValue) => {
                    setFieldValue('towerEquipments', newValue);
                    setFieldValue(
                      'equiposIds',
                      newValue?.map((team) => team?.id)
                    );
                  }}
                  options={newParams.towerEquipmentsOptions}
                  placeholder="Seleccioná un equipo de torre"
                  type="text"
                  value={values.towerEquipments}
                  withSelect="100%"
                />
              </Row>
            )}
          </>
        )}
        <Row>
          <Col sm={6}>
            <SelectGeneric
              defaultValueOneOption={false}
              label="Posición"
              name="position"
              onChange={(newValue) => {
                setFieldValue('line', null);
                setFieldValue('position', newValue);
                getLineOptions(newValue);
                cleanErrorPositionLine();
              }}
              options={newParams?.positionOptions}
              placeholder="--"
              type="text"
              value={values.position}
              withSelect="100%"
            />
          </Col>
          <Col sm={6}>
            <SelectGeneric
              defaultValueOneOption={false}
              isDisabled={Boolean(!values.position)}
              label="Línea"
              name="line"
              onChange={(newValue) => {
                setFieldValue('line', newValue);
                cleanErrorPositionLine();
                handleChangePositionLine({ valueLine: newValue });
              }}
              options={newParams?.lineOptions}
              placeholder="--"
              type="text"
              value={values.line}
              withSelect="100%"
            />
          </Col>
          <Col>
            <PositionLineContainer
              positionLine={values?.posicionesLineas}
              setValues={setValues}
              values={values}
            />
            {!!errorPositionLine?.length && (
              <span className={styles['filter-alert']}>{errorPositionLine}</span>
            )}
          </Col>
        </Row>
        <div className="container-buttons">
          <Button label="Limpiar" onClick={handleClear} type="button" variant="outline-primary" />
          <Button
            label="Guardar"
            onClick={handleSaveFilters}
            type="button"
            variant="outline-primary"
          />
          <Button label="Buscar" type="submit" variant="primary" />
        </div>
      </form>
    </div>
  );
};

FilterForm.propTypes = {
  show: PropTypes.bool.isRequired,
  isOrderByUbication: PropTypes.bool
};

FilterForm.defaultProps = {
  isOrderByUbication: undefined
};

export default FilterForm;
